/* ============================================================
   PurpleGreens® Tooltip-System — JavaScript
   Datei: pg-tooltips.js
   Version: 3.0 — 12.05.2026
   
   Änderungen ggü. v2:
   - Tooltip wird per JS an <body> portaliert (Portal-Pattern)
     → kein Clipping mehr durch parent overflow:hidden
   - Auto-Position oben/unten je nach Platz
   - Auto-Horizontal-Adjust, wenn Tooltip am Viewport-Rand ist
   - Tooltip-Pfeil folgt der korrekten Position
   ============================================================ */

(function() {
  'use strict';

  // ============================================================
  // TEIL 1: AUTO-REPLACE [i: ...] in Tooltip-Buttons
  // ============================================================

  var TOOLTIP_REGEX = /\[i:\s*([\s\S]+?)\]/g;
  var SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'BUTTON'];

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildTooltipHTML(claimText) {
    var safe = escapeHtml(claimText.trim());
    return '<button class="pg-info" aria-label="Mehr Informationen" type="button">i<span class="pg-tip">' + safe + '</span></button>';
  }

  function processTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.indexOf('[i:') === -1) return false;

    TOOLTIP_REGEX.lastIndex = 0;
    if (!TOOLTIP_REGEX.test(text)) return false;

    TOOLTIP_REGEX.lastIndex = 0;
    var newHTML = '';
    var lastIndex = 0;
    var match;

    while ((match = TOOLTIP_REGEX.exec(text)) !== null) {
      newHTML += escapeHtml(text.substring(lastIndex, match.index));
      newHTML += buildTooltipHTML(match[1]);
      lastIndex = TOOLTIP_REGEX.lastIndex;
    }
    newHTML += escapeHtml(text.substring(lastIndex));

    var wrapper = document.createElement('span');
    wrapper.className = 'pg-tooltip-wrapper';
    wrapper.innerHTML = newHTML;

    textNode.parentNode.replaceChild(wrapper, textNode);
    return true;
  }

  function walkAndReplace(root) {
    if (!root) return;

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function(node) {
          if (!node.nodeValue || node.nodeValue.indexOf('[i:') === -1) {
            return NodeFilter.FILTER_REJECT;
          }
          var parent = node.parentNode;
          while (parent && parent !== root) {
            if (SKIP_TAGS.indexOf(parent.tagName) !== -1) {
              return NodeFilter.FILTER_REJECT;
            }
            if (parent.classList && parent.classList.contains('pg-tooltip-wrapper')) {
              return NodeFilter.FILTER_REJECT;
            }
            parent = parent.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) {
      nodes.push(current);
    }
    nodes.forEach(processTextNode);
  }

  // ============================================================
  // TEIL 2: PORTAL-TOOLTIP (Tooltip an <body> hängen)
  // ============================================================

  var portalEl = null;
  var activeBtn = null;

  function getOrCreatePortal() {
    if (portalEl) return portalEl;
    portalEl = document.createElement('div');
    portalEl.className = 'pg-tip-portal';
    portalEl.setAttribute('role', 'tooltip');
    document.body.appendChild(portalEl);
    return portalEl;
  }

  function positionTooltip(btn) {
    var portal = getOrCreatePortal();
    var tipSource = btn.querySelector('.pg-tip');
    if (!tipSource) return;

    portal.textContent = tipSource.textContent;

    // Sichtbarkeit für Messung vorbereiten
    portal.classList.remove('is-above', 'is-below');
    portal.style.visibility = 'hidden';
    portal.style.opacity = '0';
    portal.style.left = '0px';
    portal.style.top = '0px';
    portal.classList.add('is-visible');

    var btnRect = btn.getBoundingClientRect();
    var tipRect = portal.getBoundingClientRect();
    var scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;

    // Vertikal: Default oberhalb, sonst unterhalb
    var spaceAbove = btnRect.top;
    var spaceBelow = vh - btnRect.bottom;
    var placeAbove = (spaceAbove > tipRect.height + 16) || (spaceAbove > spaceBelow);

    var top;
    if (placeAbove) {
      top = btnRect.top + scrollY - tipRect.height - 10;
      portal.classList.add('is-above');
    } else {
      top = btnRect.bottom + scrollY + 10;
      portal.classList.add('is-below');
    }

    // Horizontal: zentriert über dem Button
    var btnCenterX = btnRect.left + (btnRect.width / 2);
    var left = btnCenterX + scrollX - (tipRect.width / 2);

    // Edge-Detection: nicht aus viewport ragen
    var padding = 8;
    if (left < scrollX + padding) {
      left = scrollX + padding;
    } else if (left + tipRect.width > scrollX + vw - padding) {
      left = scrollX + vw - tipRect.width - padding;
    }

    // Pfeil-Position relativ zur Tooltip-Breite
    var arrowOffset = btnCenterX + scrollX - left;
    portal.style.setProperty('--pg-arrow-left', arrowOffset + 'px');

    portal.style.left = left + 'px';
    portal.style.top = top + 'px';

    portal.style.visibility = '';
    portal.style.opacity = '';
  }

  function hideTooltip() {
    if (!portalEl) return;
    portalEl.classList.remove('is-visible');
    if (activeBtn) {
      activeBtn.classList.remove('is-active');
      activeBtn.setAttribute('aria-expanded', 'false');
    }
    activeBtn = null;
  }

  function showTooltip(btn) {
    if (activeBtn && activeBtn !== btn) hideTooltip();
    activeBtn = btn;
    btn.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    positionTooltip(btn);
  }

  function toggleTooltip(btn) {
    if (activeBtn === btn) {
      hideTooltip();
    } else {
      showTooltip(btn);
    }
  }

  // ============================================================
  // TEIL 3: EVENT-BINDING
  // ============================================================

  function bindTooltipInteractions() {
    var tooltips = document.querySelectorAll('.pg-info');
    if (!tooltips.length) return;

    tooltips.forEach(function(btn) {
      if (btn.dataset.pgBound === '1') return;
      btn.dataset.pgBound = '1';
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('mouseenter', function() {
        showTooltip(btn);
      });
      btn.addEventListener('mouseleave', function() {
        if (activeBtn === btn) hideTooltip();
      });

      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleTooltip(btn);
      });

      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleTooltip(btn);
        }
        if (e.key === 'Escape') {
          hideTooltip();
          btn.blur();
        }
      });

      btn.addEventListener('focus', function() {
        showTooltip(btn);
      });
      btn.addEventListener('blur', function() {
        setTimeout(function() {
          if (document.activeElement !== btn && activeBtn === btn) hideTooltip();
        }, 100);
      });
    });
  }

  function bindGlobalHandlers() {
    if (window._pgGlobalBound) return;
    window._pgGlobalBound = true;

    document.addEventListener('click', function(e) {
      if (activeBtn && !activeBtn.contains(e.target)) hideTooltip();
    });

    window.addEventListener('scroll', function() {
      if (activeBtn) positionTooltip(activeBtn);
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (activeBtn) positionTooltip(activeBtn);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && activeBtn) hideTooltip();
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  function init(root) {
    root = root || document.body;
    walkAndReplace(root);
    bindTooltipInteractions();
    bindGlobalHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(e) { init(e.target || document.body); });
  document.addEventListener('shopify:section:reorder', function() { init(); });
  document.addEventListener('shopify:block:select', function() { init(); });
  document.addEventListener('cart:updated', function() { init(); });
  document.addEventListener('popover:open', function() { setTimeout(init, 50); });
  document.addEventListener('open', function() { setTimeout(init, 50); }, true);

  window.PGTooltips = { init: init, show: showTooltip, hide: hideTooltip };

})();